import { useApolloClient, useSubscription } from '@apollo/client';
import { FC, useEffect } from 'react';
import { GATE_MESSAGE_RECEIVED } from '../graphql/subscriptions/gateMessageReceived';
import { refreshActiveGateDataWhenVisible } from '../utils/refreshActiveGateData';
import { refreshGateMovementsHistory } from '../utils/refreshGateMovementsHistory';

export const GateMessagesSubscription: FC = () => {
  const client = useApolloClient();

  useSubscription(GATE_MESSAGE_RECEIVED, {
    onData({ data }) {
      const gateId = data.data?.gateMessageReceived.movements.id;
      if (!gateId) return;

      void refreshGateMovementsHistory(client, gateId);
    },
  });

  useEffect(() => {
    const handleVisibilityChange = () => {
      void refreshActiveGateDataWhenVisible(client, document.visibilityState);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [client]);

  return null;
};
